import { cartTotalDisplayStyles } from "@insite/content-library/Components/CartTotalDisplay";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

cartTotalDisplayStyles.container = {
    gap: 10,
    css: css`
        background-color: ${getColor("secondary")};
        margin-bottom: 15px;
        padding: 15px 10px;
        border-radius: 8px;

        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    padding: 10px;
                `,
                css`
                    padding: 10px;
                `,
                css``,
                css``,
                null,
            ])}
    `,
};
// --------------------------------------------------------
